// @flow
import { CRUISE_PROGRAM } from 'Client/cms/toolkit/constants';
import { CruiseProgramLine } from 'Components/lines/cruise-program-line/CruiseProgramLine.jsx';
import { cruiseProgramResolver } from './cruiseProgram.resolver';

export const cruiseProgramDescriptor = {
  name: CRUISE_PROGRAM,
  component: CruiseProgramLine,
  resolve: cruiseProgramResolver.resolve,
};
